<template>
  <div>
    <div class="cc-events-txt">
      <div>GLOBAL AWARDS</div>
    </div>
    <br />
    <div>
      <router-link :to="{ name: 'ccAllEvents' }">
        <button class="awards-back-all-events">Upcoming Events</button>
      </router-link>
    </div>
    <div class="EventList" v-for="award in awards" :key="award.id">
      <b-container class="bv-example-row">
        <router-link
          :to="{ name: 'globalAwardsEvents', params: { awardId: award.id, slug: award.slug } }"
        >
          <b-row>
            <b-col class="forEventDate">
              <p class="eventDate">
                {{ $formatDate.getUTCDate(award.start_date) }} -
                {{ $formatDate.getUTCDate(award.end_date) }} <br />
                {{ $formatDate.getUTCMonth(award.start_date) }}
                {{ $formatDate.getUTCYear(award.start_date) }}
              </p>
            </b-col>
            <b-col sm="2" class="forEventImg">
              <b-img :src="award.main_banner"></b-img>
            </b-col>
            <b-col class="forEventParaghraph">
              <div class="eventTxt" v-html="award.name"></div>
              <p class="eventCity">
                {{ award.city }}
              </p>
            </b-col>
          </b-row>
        </router-link>
      </b-container>
    </div>
    <infinite-loading
      @infinite="awardInfiniteHandler"
      :identifier="awardInfiniteHandlerId"
    >
      <div slot="no-more" />
      <div slot="no-results" />
    </infinite-loading>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'AllAwards',

  data() {
    return {
      awards: [],
      awardPage: 1,
      awardsNextPage: true,
      awardInfiniteHandlerId: uuidv4(),
    };
  },
  async mounted() {
    const { results, next } = await this.fetchAwards();
    this.awards = results;
    this.awardsNextPage = !!next;
  },
  methods: {
    ...mapActions({
      fetchAwards: 'awards/fetchAwards',
    }),
    async awardInfiniteHandler($state) {
      try {
        if (this.awardsNextPage) {
          const { awardPage } = this;
          const data = await this.fetchAllUsers(awardPage);
          this.awardsNextPage = !!data.next;
          this.awardPage += 1;
          this.awards.push(...data.results);
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (err) {
        $state.complete();
      }
    },
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
    eventDays(start, end) {
      let day = this.moment(start).format('DD');
      if (start !== end) {
        day = `${this.moment(start).format('DD')} - ${this.moment(end).format(
          'DD',
        )}`;
      }
      return day;
    },
  },
};
</script>
<style scoped>
.cc-events-txt {
  text-align: center;
  background: white;
  height: 61px;
  color: #333333;
  font-family: Montserrat;
  line-height: 1.4;
  font-size: 30px;
  text-transform: uppercase;
}
.eventDate {
  font-size: 15px;
  color: #bd9d5f;
  line-height: 17px;
  padding: 5px;
}
.forEventDate {
  max-width: 61px !important;
  min-width: 61px;
  height: 61px !important;
  padding: 0px;
  text-align: center;
  background-color: #ffffff;
}
.forEventImg {
  max-width: 142px !important;
  min-width: 62px;
  height: 61px !important;
  padding: 0px;
  background-color: white;
}
.forEventImg > img {
  width: 61px;
  height: 61px;
  object-fit: cover;
}
.forEventParaghraph {
  background-color: #ffffff;
  padding: 13px 7px 0px 15px;
  height: 61px;
}
.eventTxt {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: unset;
  text-overflow: ellipsis;
  line-height: 14px;
  margin-bottom: 5px;
}
.EventList {
  margin-top: 20px;
}
.eventCity {
  margin: 0;
  color: #666;
  font-size: 12px;
  line-height: 14px;
}
.awards-back-all-events {
  color: white;
  background-color: #bd9d5f;
  padding: 3px 7px 3px 9px;
  font-size: 12px;
  border: none;
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
